/* eslint-disable */
import actions from './actions';
import * as types from './types';

const initialState = () => ({
  configurations: [],
  configuration: {
    hash: '',
    name: '',
    css: '',
    api_key: '',
    requiresIFrame: false,
    iFrameJsLink: '',
    hideDealerStage: false,
    hasCustomCSS: false,
    gtm: {
        enabled: false
    },
    omniture: {
      enabled: false,
      url: null
    }
  }
});
const state = initialState();

const getters = {
  configurations: state => {
    return state.configurations;
  },
  configuration: state => {
    return state.configuration;
  },
};

const mutations = {
  [types.LIST_CONFIGURATIONS_SUCCESS](state, data){
    state.configurations = data;
  },
  [types.GET_CONFIGURATION_SUCCESS](state, data){
    state.configuration = {...initialState().configuration, ...data};
  },
  [types.UPDATE_CONFIGURATIONS](state, data){
    state.configurations = data;
  },
  [types.UPDATE_CONFIGURATION](state, data){
    state.configuration = data;
  },
  [types.RESET_CONFIGURATIONS](state){
    state.configurations = {};
  },
  [types.RESET_CONFIGURATION](state) {
    state.configuration = initialState().configuration;
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/configuration/index.js